import nlp from 'compromise';
// import { sentenceCase } from 'text-sentence-case';
import { titleCase } from 'title-case';

export function tokenizeLatex(str) {
    const tokens = [];
    let i = 0;
    let plainBuf = '';

    function flushPlain() {
        if (plainBuf.length > 0) {
            tokens.push({ type: 'text', value: plainBuf });
            plainBuf = '';
        }
    }

    function consumeBalanced(openChar, closeChar) {
        let tok = openChar;
        let depth = 1;
        i++; // skip the opening char
        while (i < str.length && depth > 0) {
            if (str[i] === openChar) depth++;
            if (str[i] === closeChar) { depth--; if (depth === 0) { tok += closeChar; i++; break; } }
            tok += str[i];
            i++;
        }
        return tok;
    }

    while (i < str.length) {

        // ── Display math: $$...$$ (must check before single $) ───────────────
        if (str[i] === '$' && str[i + 1] === '$') {
            flushPlain();
            let tok = '$$';
            i += 2;
            while (i < str.length && !(str[i] === '$' && str[i + 1] === '$')) {
                tok += str[i]; i++;
            }
            tok += '$$'; i += 2;
            tokens.push({ type: 'math', value: tok });
            continue;
        }

        // ── Inline math: $...$ ────────────────────────────────────────────────
        if (str[i] === '$') {
            flushPlain();
            let tok = '$';
            i++;
            while (i < str.length && str[i] !== '$') {
                if (str[i] === '\\') { tok += str[i]; i++; } // skip escaped chars
                tok += str[i]; i++;
            }
            tok += '$'; i++;
            tokens.push({ type: 'math', value: tok });
            continue;
        }



        // ── LaTeX command: \cmdname [opt]{arg}{arg}... ────────────────────────
        if (str[i] === '\\' && i + 1 < str.length && /[a-zA-Z*@]/.test(str[i + 1])) {
            flushPlain();
            let tok = '\\';
            i++;

            // Consume command name
            while (i < str.length && /[a-zA-Z*@]/.test(str[i])) {
                tok += str[i]; i++;
            }

            // \( ... \)  inline math environment
            if (tok === '\\(') {
                while (i < str.length) {
                    if (str[i] === '\\' && str.slice(i, i + 2) === '\\)') { tok += '\\)'; i += 2; break; }
                    tok += str[i]; i++;
                }
                tokens.push({ type: 'math', value: tok }); continue;
            }

            // \[ ... \]  display math environment
            if (tok === '\\[') {
                while (i < str.length) {
                    if (str[i] === '\\' && str.slice(i, i + 2) === '\\]') { tok += '\\]'; i += 2; break; }
                    tok += str[i]; i++;
                }
                tokens.push({ type: 'math', value: tok }); continue;
            }

            // Greedily consume all immediately-following argument groups.
            // Spaces between the command name and its first argument are included.
            while (i < str.length) {
                // Peek for optional whitespace then an argument delimiter
                let ws = '';
                while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
                    ws += str[i]; i++;
                }
                if (str[i] === '{') {
                    tok += ws + consumeBalanced('{', '}');
                } else if (str[i] === '[') {
                    tok += ws + consumeBalanced('[', ']');
                } else {
                    // No argument follows — backtrack any whitespace we peeked at
                    if (ws.length > 0) i -= ws.length;
                    break;
                }
            }

            tokens.push({ type: 'command', value: tok });
            continue;
        }

        // ── Plain text character ───────────────────────────────────────────────
        plainBuf += str[i];
        i++;
    }

    flushPlain();
    return tokens;
}


function isAbbreviation(word) {
    const letters = word.match(/[a-zA-Z]/g);
    if (!letters || letters.length < 2) return false;
    return letters.every(ch => ch === ch.toUpperCase());
}


export function applyCustomCase(str, transformFn) {
    str = str.trim();
    if (!str) return str;

    const tokens = tokenizeLatex(str);
    let firstTextSeen = false;
    let resetNext = false;

    return tokens.map((tok, i) => {
        if (tok.type !== 'text') return tok.value;

        const isFirst = !firstTextSeen;
        if (/[a-zA-Z]/.test(tok.value)) firstTextSeen = true;

        const segments = tok.value.split(/(\b[a-zA-Z]+\b)/);
        let isFirstSegment = isFirst;

        return segments.map((seg, idx) => {
            const isWordSegment = idx % 2 === 1;

            if (isWordSegment) {
                if (isAbbreviation(seg)) {
                    isFirstSegment = false;
                    return seg;
                }


                const shouldBeFirst = isFirstSegment || resetNext;
                const result = transformFn(seg, shouldBeFirst);

                resetNext = false;
                isFirstSegment = false;
                return result;
            }

            if (/[.!?:]/.test(seg)) {
                resetNext = true;
            }
            if (/[,]/.test(seg)) {
                resetNext = true;
            }
            return transformFn(seg, false);
        }).join('');
    }).join('');
}



export function applyFirstLetterOnlyCase(str, transformFn) {
    str = str.trim();
    if (!str) return str;

    const tokens = tokenizeLatex(str);
    let firstTextSeen = false;
    let resetNext = false;

    return tokens.map((tok, i) => {
        if (tok.type !== 'text') return tok.value;

        const isFirst = !firstTextSeen;
        if (/[a-zA-Z]/.test(tok.value)) firstTextSeen = true;

        const segments = tok.value.split(/(\b[a-zA-Z]+\b)/);
        let isFirstSegment = isFirst;

        return segments.map((seg, idx) => {
            const isWordSegment = idx % 2 === 1;

            if (isWordSegment) {
                if (isAbbreviation(seg)) {
                    isFirstSegment = false;
                    return seg;
                }


                const shouldBeFirst = isFirstSegment || resetNext;
                const result = transformFn(seg, shouldBeFirst);

                resetNext = false;
                isFirstSegment = false;
                console.log("the value come from the transformFn with caps or usuall", result);
                return result;
            }

            // if (/[.!?:]/.test(seg)) {
            if (/[.!?:]/.test(seg)) {
                resetNext = true;
            }

            return transformFn(seg, false);
        }).join('');
    }).join('');
}






export function changeToSentenceCase(content) {
    if (!content || !content.trim()) return content;

    return applyCustomCase(content, (text, isFirst) => {
        // Only process segments that contain letters
        if (/[a-zA-Z]/.test(text)) {
            let doc = nlp(text);
            if (isFirst) {
                // if (doc.has('#Preposition')) {
                //     return text.toLowerCase();
                // }
                return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            }
            console.log("the word is in nlp ", text, "the noun is ", doc.has('#Noun'))
            if (doc.has('#ProperNoun') || doc.has('#Acronym') || doc.has('#TitleCase') || doc.has('#Noun')) {
                return text; // Keep it exactly as it is (e.g., "Ajith")
                // return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            }
            console.log("the word is in nlp ", text, "the preposition is ", doc.has('#Preposition'))
            if (doc.has('#Preposition')) {
                return text.toLowerCase();
            }

            // 3. Otherwise, make it lowercase
            return text.toLowerCase();
        }

        return text;
    });
}




const TITLE_SKIP_WORDS = new Set([
    'a', 'an', 'the',
    'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
    'at', 'by', 'in', 'of', 'on', 'to', 'up', 'as', 'if',
    'into', 'onto', 'via', 'per', 'than', 'from', 'with',
    'over', 'past', 'down', 'near', 'like',
]);

// export function changeToTitleCase(content) {
//     if (!content || !content.trim()) return content;

//     let isFirstWord = true;

//     return applyCustomCase(content, (text) => {
//         return text.replace(/([a-zA-Z]+)/g, (word) => {
//             const lower = word.toLowerCase();
//             const shouldCap = isFirstWord || !TITLE_SKIP_WORDS.has(lower);
//             isFirstWord = false;
//             return shouldCap
//                 ? lower[0].toUpperCase() + lower.slice(1)
//                 : lower;
//         }).replace(/[^a-zA-Z]+/g, match => {
//             if (/[.!?]/.test(match)) isFirstWord = true;
//             return match;
//         });
//     });
// }


// export function changeToTitleCase(content) {
//     if (!content || !content.trim()) return content;

//     return titleCase(content);
// }

export function changeToKeywordCase(content) {
    if (!content || !content.trim()) return content;
    const doc = nlp(content);
    const detectedNames = new Set();

    doc.people().forEach(person => {
        person.out('text').split(/\s+/).forEach(word => {
            const clean = word.replace(/[^a-zA-Z]/g, '').toLowerCase();
            if (clean.length > 0) detectedNames.add(clean);
        });
    });
    console.log("detected names are ", detectedNames);
    let output = applyFirstLetterOnlyCase(content, (text, isFirst) => {
        if (!/[a-zA-Z]/.test(text)) return text;
        if (isFirst) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
        const cleanText = text.replace(/[^a-zA-Z]/g, '').toLowerCase();
        if (detectedNames.has(cleanText)) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
        // console.log("the word is :", cleanText, "is propernoun or not:", doc.has("#ProperNoun"))
        // if (doc.has("#ProperNoun")) {
        //     return text.charAt(0).toUpperCase() + text.slice(1)
        // }
        return text;
    });
    console.log("the output is ", output)
    return output;
}

// export function changeToKeywordCase(content) {
//     if (!content || !content.trim()) return content;
//     const doc = nlp(content);
//     const detectedNames = new Set();
//     const result = sentenceCase(content);
//     return result;

// }




export function changeToLowerCase(content) {
    return applyCustomCase(content, (text) => text.toLowerCase());
}


export function changeToUpperCase(content) {
    return applyCustomCase(content, (text) => text.toUpperCase());
}






export function changeToTitleCase(content) {
    let tokens = [];
    let textdata = "";
    let order = 0;

    function flush() {
        if (textdata.length > 0) {
            order++;
            tokens.push({
                type: "text",
                data: textdata,
                orderposition: order
            });
            textdata = "";
        }
    }

    function extractMath(content, i, openDelim, closeDelim) {
        let mathContent = openDelim;
        i += openDelim.length;
        while (i < content.length) {
            if (content.startsWith(closeDelim, i)) {
                mathContent += closeDelim;
                i += closeDelim.length;
                break;
            }
            mathContent += content[i];
            i++;
        }
        return { mathContent, newIndex: i };
    }

    for (let i = 0; i < content.length; i++) {
        if (content.startsWith("$$", i)) {
            flush();
            const { mathContent, newIndex } = extractMath(content, i, "$$", "$$");
            order++;
            tokens.push({ type: "math", data: mathContent, orderposition: order });
            i = newIndex - 1;

        } else if (content[i] === "$") {
            flush();
            const { mathContent, newIndex } = extractMath(content, i, "$", "$");
            order++;
            tokens.push({ type: "math", data: mathContent, orderposition: order });
            i = newIndex - 1;

        } else if (content.startsWith("\\(", i)) {
            flush();
            const { mathContent, newIndex } = extractMath(content, i, "\\(", "\\)");
            order++;
            tokens.push({ type: "math", data: mathContent, orderposition: order });
            i = newIndex - 1;

        } else if (content.startsWith("\\[", i)) {
            flush();
            const { mathContent, newIndex } = extractMath(content, i, "\\[", "\\]");
            order++;
            tokens.push({ type: "math", data: mathContent, orderposition: order });
            i = newIndex - 1;

        } else {
            textdata += content[i];
        }
    }

    flush();

    // Sentence case: only capitalize first letter of the entire content


    const cased = tokens.map(token => {
        if (token.type === "text") {
            return { ...token, data: toTitleCase(token.data) };
        }
        return token; // math is never touched
    });

    const result = cased
        .sort((a, b) => a.orderposition - b.orderposition)
        .map(t => t.data)
        .join("");

    console.log("Final tokens:", cased);
    return result;
}

// function toSentenceCase(str) {
//     console.log("the data coming to the tosentececase is :", str);
//     // Capitalize only the first actual letter, skip leading spaces/symbols
//     return str.replace(/^\s*([a-z])/, char => char.toUpperCase());
// }


// function toSentenceCase(str) {
//     return sentenceCase(str);
// }


function toTitleCase(str) {
    return titleCase(str);
}
